import React from "react";
import { Link as RouterLink } from 'react-router-dom';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import {globalTheme} from './Theme'

const useStyles = makeStyles((theme) => ({
    root: {
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    button: {
        //background: 'linear-gradient(45deg, #FE6B8B 30%, #FF8E53 90%)',
        background: 'rgba(155,155,155, 0.25)',
        //color: "#95b4da",
        padding: "13px",
        flexGrow: 1,
        [theme.breakpoints.down('md')]: {
          padding: "5px",
        },
    },
  }));

export default function Navitem(props) {
    const classes = useStyles(globalTheme);

    return (
        <Button 
          key={props.item + "_projectsNav"}
          className={props.buttonClass === undefined ? classes.button: props.buttonClass} 
          size='large'
          color="secondary"
          component={RouterLink} 
          startIcon={props.icon} 
          to={props.tolink}
          onClick={props.onClick}>
            {props.item}
        </Button>
    );
}